// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module './Ap... Remove this comment to see the full error message
import Application from './Application';
new Application().start();